export default __webpack_public_path__ + "4e8a470398c0a0c0bc366dc996e16fe3.woff2";